<div mat-dialog-title>
  <h1 class="title">
    {{ ('Gestisci vocabolario' | translate) + ' ' + data.vocabulary.nome }}
  </h1>
  <div class="terms-breadcrumb">
    <button
      matButton
      *ngIf="selectedTerms.length > 0"
      (click)="removeAllSelectedTermsHandler()">
      <mat-icon>clear</mat-icon>
    </button>
    <ng-container *ngFor="let t of selectedTerms; let last = last, let i = index">
      <a
        class="term-value"
        (click)="selectTermBreadcrumbHandler(t, i)">
        {{ t.valore }}
      </a>
      <mat-icon
        *ngIf="!last"
        class="term-arrow">
        keyboard_arrow_right
      </mat-icon>
    </ng-container>
    <p *ngIf="selectedTerms.length === 0">
      {{ 'Ti trovi sul livello più alto della gerarchia dei termini.' | translate }}
    </p>
  </div>
</div>
<mat-dialog-content>
  <div
    *roleVisibility="['create']; classNames: ['Termine']"
    class="new-term-form">
    <mat-form-field>
      <input
        matInput
        #newTermInput
        [placeholder]="'Nuovo termine' | translate">
      <mat-hint *ngIf="newTermInput.value && getLastSelectedTerm() as lastTerm">
        {{ ('Il termine verrà inserito con termine genitore' | translate) + ': ' + lastTerm?.valore }}
      </mat-hint>
    </mat-form-field>
    <button
      mat-button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="!newTermInput.value"
      (click)="addTermHandler(newTermInput.value, selectedVocabulary); newTermInput.value = ''">
      {{ 'Inserisci nuovo termine' | translate }}
    </button>
  </div>

  <mat-form-field
    class="input-expanse"
    appearance="outline">
    <input
      matInput
      #termSearchElement
      [placeholder]="'Cerca un termine'"
      (keyup)="searchTermHandler(termSearchElement.value)">
  </mat-form-field>

  <ui-table
    *ngIf="pager$ | async as pager"
    [fields]="fields"
    [pager]="pager"
    [itemsPage]="(page$ | async)?.current"
    [itemsPerPage]="(page$ | async)?.limit"
    [reload]="reload$"
    [filters]="filters$ | async"
    [contextMenuActions]="contextMenus"
    (select)="selectHandler($event)">
  </ui-table>
</mat-dialog-content>
